module.exports = __webpack_public_path__ + "img/sesame.91f478be.png";